/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const hyperliquid_chain_about = () => `Hyperliquid is a Layer 1 blockchain that aims to enhance the efficiency and performance of DeFi applications, especially perpetual futures trading. It offers zero gas fees, instant finality, and a fully on-chain order book for its users.`
